/** Align legacy DB keys with current registry keys (keep in sync with api migrateLegacyConfig). */
export function migrateStepConfigOverrides(
  stepCode: string,
  overrides: Record<string, unknown> | null | undefined
): Record<string, unknown> {
  if (!overrides || typeof overrides !== 'object') return {};
  const o = { ...overrides };
  if (stepCode === 'ART_CATEGORIES') {
    if ('minSelections' in o && !('minCategories' in o)) {
      o.minCategories = o.minSelections;
      delete o.minSelections;
    }
    if ('maxSelections' in o && !('maxCategories' in o)) {
      o.maxCategories = o.maxSelections;
      delete o.maxSelections;
    }
  }
  return o;
}
